module.exports = __webpack_public_path__ + "/images/gfl-logo.small.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp-files/images/gfl-logo.small.png
// module id = 206
// module chunks = 0